export type PrintComCompatibilityIssue = {
  code: string;
  message: string;
  keys: string[];
};

const POSTER_SKUS = new Set(['posters', 'photo-poster', 'photo_poster', 'foto-op-poster', 'foto_op_poster', 'poster']);

export const POSTER_MATERIALS_WITHOUT_FINISH = new Set([
  '95gr_neon_papier_geel',
  '95gr_neon_papier_groen',
  '95gr_neon_papier_magenta',
  '95gr_neon_papier_oranje',
  '115gr_blueback',
  '120gr_biotop',
  '120gr_recystar',
  '120gr_recystar_nature',
  '135gr_gesatineerd_mc',
  '135gr_silk_mc',
  '150gr_citylight',
  '160gr_ijm814_uncoated',
  '170gr_gesatineerd_mc',
  '170gr_silk_mc',
  '170gr_synaps',
  '230gr_premium_matt',
  '280gr_backlit_polyester',
  '510gr_pvc',
]);

export const NO_POSTER_FINISH_VALUES = new Set([
  'geen',
  'none',
  'no',
  'no_laminate',
  'no_lamination',
  'without_lamination',
]);

export function isPrintComPosterSku(value: unknown) {
  return POSTER_SKUS.has(String(value || '').toLowerCase());
}

export function isNoPosterFinishValue(value: unknown) {
  return NO_POSTER_FINISH_VALUES.has(String(value ?? '').toLowerCase());
}

export function isPosterMaterialWithoutFinish(value: unknown) {
  return POSTER_MATERIALS_WITHOUT_FINISH.has(String(value ?? ''));
}

export function getPrintComOptionCompatibilityIssue(args: {
  sku?: unknown;
  productSlug?: unknown;
  providerProductId?: unknown;
  options?: Record<string, unknown> | null;
}): PrintComCompatibilityIssue | null {
  const productKey = args.providerProductId ?? args.sku ?? args.productSlug;
  if (!isPrintComPosterSku(productKey)) return null;

  const options = args.options || {};
  const material = options.material;
  const finish = options.finish;

  if (
    material !== undefined &&
    finish !== undefined &&
    isPosterMaterialWithoutFinish(material) &&
    !isNoPosterFinishValue(finish)
  ) {
    return {
      code: 'INVALID_PRINTCOM_OPTION_COMBINATION',
      message: 'Deze materiaal-afwerking combinatie is niet beschikbaar bij Print.com.',
      keys: ['material', 'finish'],
    };
  }

  return null;
}
